import { useNavigate } from 'react-router-dom';
import '../styles/page.css';
import { useEffect, useState } from 'react';
import { IPrivacyInfo } from '../../interface/common';
import AOS from 'aos';
import 'aos/dist/aos.css';

function Privacy() {
  const navigate = useNavigate();

  const [privacyInfo, setPrivacyInfo] = useState<IPrivacyInfo>();

  // 공지사항 목록으로 이동
  const hadleList = () => {
    navigate(`/`);
  };

  const handleSearch = async () => {
    await fetch(`/common/privacyInfo`, {
      method: 'GET',
      headers: { 'Content-Type': 'applications/json' },
    })
      .then((response) => response.json())
      .then((result) => {
        setPrivacyInfo(result);
      })
      .catch((error) => {
        console.error('Error fetching data:', error);
      });
  };

  useEffect(() => {
    AOS.init();
    handleSearch();
  }, []);

  return (
    <>
      <section id="notice-banner">
        <div className="page-banner-bg">
          <div className="m-auto page-banner-container">
            <h2 data-aos="fade-right" data-aos-duration="700" data-aos-once="true">
              개인정보처리방침
            </h2>
            <p
              className="color-caption fs-md"
              data-aos="fade-right"
              data-aos-duration="700"
              data-aos-once="true"
              data-aos-delay="200"
            >
              이용자의 개인정보를 안전하게 관리하기위해 개인정보보호법에 따른
              <br />
              법적 요구사항을 모두 준수하고 있습니다.
            </p>
          </div>
        </div>
      </section>

      <main id="notice-detail">
        <div className="notice-detail-container m-auto">
          <div className="notice-detail-body">{privacyInfo?.privacyInfo}</div>

          <div className="notice-btn-box">
            <button type="button" onClick={hadleList}>
              메인으로
            </button>
          </div>
        </div>
      </main>
    </>
  );
}

export default Privacy;
